module.exports = __webpack_public_path__ + "static/img/noResult@2x.6cf70511.png";